module.exports = __webpack_public_path__ + "static/318503382_666026165193822_1805355563868328223_n.jpg-1671186393568_256-f4c56625b114e26739662816f8cbfb36.webp";